import { Progress } from "antd";

export const columns = [
  {
    title: "Sector",
    dataIndex: "name",
  },
  {
    title: "Market Widget",
    dataIndex: "overview.market_weight",
    render: (text, row) => {
      let markerWeight = row?.overview?.market_weight * 100;
      markerWeight =
        markerWeight && markerWeight !== 0 ? markerWeight.toFixed(2) : 0;
      return (
        <>
          <Progress
            percent={markerWeight}
            format={(percent) => (
              <span style={{ color: "black" }}>{percent}%</span>
            )}
            percentPosition={{
              type: "outer",
              align: "end",
            }}
            size={[150, 15]}
            strokeColor="#7eabd6"
          />
        </>
      );
    },
  },
  {
    title: "Industries",
    dataIndex: "industries_count",
    render: (text, row) => {
      return row?.overview?.industries_count;
    },
  },
  {
    title: "Companies",
    dataIndex: "companies_count",
    render: (text, row) => {
      return row?.overview?.companies_count;
    },
  },
];

export const dataSource = [
  {
    key: "all_sectors",
    sector: "All Sectors",
    marketWidget: 100,
    trends: "+25.5%",
  },
  {
    key: "2",
    sector: "Technology",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+12.3%",
  },
  {
    key: "3",
    sector: "Financial Services",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+8.7%",
  },
  {
    key: "4",
    sector: "Consumer Cyclical",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+15.2%",
  },
  {
    key: "5",
    sector: "Health Care",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+10.4%",
  },
  {
    key: "6",
    sector: "Communication Services",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+9.8%",
  },
  {
    key: "7",
    sector: "Industrial Goods",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+18.6%",
  },
  {
    key: "8",
    sector: "Consumer Defensive",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+7.3%",
  },
  {
    key: "9",
    sector: "Energy",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+11.1%",
  },
  {
    key: "10",
    sector: "Real Estate",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+13.5%",
  },
  {
    key: "11",
    sector: "Basic Materials",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+6.9%",
  },
  {
    key: "12",
    sector: "Utilities",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+16.9%",
  },
];

export const Risks = {
  total_risks: "Total Risks",
  high_impact_risks: "High Impact Risks",
  mitigated_risks: "Mitigated Risks",
  unaddressed_risks: "Unaddressed Risks",
};

export const Opportunities = {
  total_opportunities: "Total Opportunities",
  realized_opportunities: "Realized Opportunities",
  unrealized_opportunities: "Unrealized Opportunities",
  archived_opportunities: "Archived Opportunities",
};
